(function () {
  var modal = document.getElementById('QuickView');
  var content = modal ? modal.querySelector('[data-quick-view-content]') : null;
  if (!modal || !content) return;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function render(product) {
    var firstAvailable = product.variants.find(function (variant) { return variant.available; }) || product.variants[0];
    var options = product.variants.map(function (variant) {
      return '<option value="' + variant.id + '" ' + (!variant.available ? 'disabled' : '') + '>' + escapeHtml(variant.title) + (!variant.available ? ' - Sold out' : '') + '</option>';
    }).join('');
    var image = product.featured_image ? '<img class="quick-view__image" src="' + product.featured_image + '" alt="' + escapeHtml(product.title) + '">' : '<div class="quick-view__image"></div>';
    content.innerHTML = '<div class="quick-view__grid">' + image + '<div><p class="eyebrow">' + escapeHtml(product.vendor || 'Fabrecia') + '</p><h2>' + escapeHtml(product.title) + '</h2><div class="price"><span>' + window.Fabrecia.formatMoney(firstAvailable.price) + '</span></div><form data-product-form method="post" action="/cart/add"><input type="hidden" name="quantity" value="1"><select name="id">' + options + '</select><button class="button button--full" type="submit">' + window.FabreciaTheme.strings.addToCart + '</button></form><a class="text-link" href="' + product.url + '">' + window.FabreciaTheme.strings.quickView + '</a></div></div>';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-view-open]');
    if (!button) return;
    event.preventDefault();
    content.innerHTML = '<p>Loading...</p>';
    modal.setAttribute('aria-hidden', 'false');
    var handle = button.getAttribute('data-product-handle');
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (res) { return res.json(); }).then(render).catch(function () {
      content.innerHTML = '<p>Quick view is unavailable right now.</p>';
    });
  });
})();
